import { getConvexClient, convexRefs } from "../convexClient";
import { getActiveToken } from "../services/api";

// Thin wrappers over the AI companion's Convex functions. Keys never come back
// to the browser — only a 4-character hint.

const client = () => {
  const convex = getConvexClient();
  if (!convex) throw new Error("Convex is not configured");
  return convex;
};
const auth = () => ({ token: getActiveToken() });

export const PROVIDERS = [
  { id: "openrouter", label: "OpenRouter", keyHint: "sk-or-v1-…", site: "openrouter.ai/keys" },
  { id: "anthropic", label: "Anthropic (Claude)", keyHint: "sk-ant-…", site: "console.anthropic.com" },
  { id: "google", label: "Google (Gemini)", keyHint: "AIza…", site: "aistudio.google.com/apikey" },
  { id: "openai", label: "OpenAI (GPT)", keyHint: "sk-…", site: "platform.openai.com/api-keys" },
  { id: "zai", label: "Z.ai (GLM)", keyHint: "…", site: "z.ai/manage-apikey" },
];
export const providerLabel = (id) =>
  (PROVIDERS.find((p) => p.id === id) || { label: id }).label;

export async function fetchAiSettings() {
  return await client().query(convexRefs.aiGetSettings, auth());
}

export async function saveAiSettings(patch) {
  return await client().mutation(convexRefs.aiSetSettings, { ...auth(), ...patch });
}

export async function saveAiKey(provider, key) {
  return await client().action(convexRefs.aiSaveKey, { ...auth(), provider, key });
}

export async function deleteAiKey(provider) {
  return await client().mutation(convexRefs.aiDeleteKey, { ...auth(), provider });
}

export async function listAiModels(provider, refresh = false) {
  return await client().action(convexRefs.aiListModels, { ...auth(), provider, refresh });
}

export async function testAiConnection(provider, model) {
  return await client().action(convexRefs.aiTest, { ...auth(), provider, model });
}

export async function fetchAiUsage(month) {
  return await client().query(convexRefs.aiUsage, {
    ...auth(),
    ...(month ? { month } : {}),
  });
}

/** One chat turn. `messages` = [{ role: "user"|"assistant", content }]. */
export async function aiChat({ system, messages, kind, temperature }) {
  return await client().action(convexRefs.aiChat, {
    ...auth(),
    system,
    messages,
    ...(kind ? { kind } : {}),
    ...(typeof temperature === "number" ? { temperature } : {}),
  });
}

/** Human message for a ConvexError thrown by the AI functions. */
export function aiErrorText(e, fallback = "Something went wrong.") {
  const d = e && e.data;
  if (d && typeof d === "object" && d.message) return d.message;
  return (e && e.message) || fallback;
}

export const fmtUsd = (n) =>
  typeof n === "number"
    ? n < 0.01
      ? `$${n.toFixed(4)}`
      : `$${n.toFixed(2)}`
    : "n/a";
